import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { isObservable, Observable } from "rxjs";

@Component({
    standalone: false,
    templateUrl: "./horizontalMultiSelect.component.html",
    styleUrls: ["./horizontalMultiSelect.component.css"],
})
export class FormlyHorizontalMultiSelect extends FieldType<FieldTypeConfig> {
    getOptions(options: any[] | Observable<any[]>): any[] | Observable<any[]> {
        if (!options) return [];
        else if (isObservable(options)) return options;
        else {
            if ((options || []).length > 0) {
                //sort the options based on alphanumeric order
                options.sort((a, b) => a.value?.toString().localeCompare(b.value, 'en', { numeric: true }));
            }

            return options;
        }
    }

    change($event) {
        if (this.props.change) this.props.change(this);
    }

    blur($event) {
        if (this.props.blurChange) this.props.blurChange(this);
    }
}
